"use client"

import HeadingElement from "@/app/(site)/_components/GCMolecules/HeadingElement"
import { fontClass } from "@/config/fontConfig/fontClass"
import { type HeadingGroupType, type HeadingLevel } from "@/types/gc-modules-types"
import { clsx } from "@/src/utils/clsx"

interface HeadingGroupProps {
    isAboveTheFold: boolean
    data: HeadingGroupType
    className?: string
    levelOverride?: HeadingLevel
}

export default function HeadingGroup({
    isAboveTheFold,
    data,
    className,
    levelOverride
}: HeadingGroupProps) {
    if (!data?.headingGroupContent) return null

    const { headingGroupContent, textColor } = data
    const {
        headingElement,
        type,
        styleKey = "Trade_Gothic_Header_32_105_0_300"
    } = headingGroupContent

    if (!headingElement?.text?.trim()) return null

    return (
        <HeadingElement
            isAboveTheFold={isAboveTheFold}
            text={headingElement.text}
            type={type}
            levelOverride={levelOverride}
            className={clsx(textColor, fontClass(styleKey), className)}
        />
    )
}
